import { default as cookies } from '_cookies.js';

const noticeCookieName = 'dismissedNoticeRTY783X';
const noticeButton = document.getElementById('headerNoticeButton');
const headerNotice = document.getElementById('headerNotice');

/**
 *
 *
 */
const init = function () {

	if (headerNotice === null) {
		return;
	}

	noticeButton.onclick = () => {
		cookies.setCookie(noticeCookieName, '1', 1);
		document.body.classList.remove('header-notice-visible');
	};

};


const api = {
	init: init
};

export default api;